/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'confluence-table-tree.column.contributors': 'Участники',
  'confluence-table-tree.column.last-modified': 'Последнее изменение',
  'confluence-table-tree.column.title': 'Название',
  'confluence-table-tree.could-not-load': 'Ошибка при загрузке',
  'confluence-table-tree.could-not-load-contributors': 'Не удалось загрузить участников',
  'confluence-table-tree.create-child-page': 'Создать дочернюю страницу',
  'confluence-table-tree.create-page': 'Создать страницу',
  'confluence-table-tree.default.page.title': 'Без названия',
  'confluence-table-tree.default.show-all-pages-button.label': 'Показать больше страниц',
  'confluence-table-tree.draft.lozenge': 'ЧЕРНОВИК',
  'confluence-table-tree.draft.tooltip': 'Черновики можете просматривать только вы.',
  'confluence-table-tree.drafts-toggle.label': 'Показать черновики',
  'confluence-table-tree.edit': 'Изменить',
  'confluence-table-tree.edit-in-confluence': 'Редактировать в Confluence',
  'confluence-table-tree.empty.description':
    'Создавайте протоколы собраний, требования к продукту, решения или другой контент, чтобы наполнить этот раздел.',
  'confluence-table-tree.empty.title': 'Здесь нет ничего, кроме потенциала',
  'confluence-table-tree.error.description': 'Невозможно показать эти страницы. Повторите попытку позже.',
  'confluence-table-tree.error.row': 'Не удалось загрузить страницы.',
  'confluence-table-tree.error.title': 'Нам так неловко...',
  'confluence-table-tree.friendly-when-created': 'Создано',
  'confluence-table-tree.friendly-when-updated': 'Дата обновления',
  'confluence-table-tree.share.copied': 'Скопировано в буфер обмена',
  'confluence-table-tree.share.copy-button': 'Скопировать',
  'confluence-table-tree.share.subtitle': 'Поделиться этой ссылкой',
  'confluence-table-tree.share.title': 'Поделиться страницей',
  'confluence-table-tree.share.tooltip': 'Поделиться',
  'confluence-table-tree.view-profile': 'Посмотреть профиль',
};
